<template>
  <div class="wrapper">
    <div
      v-if="debugProdcessingResults"
      class="processing-result-debug"
    >
      <div class="debugging-status">
        Payment Status: {{ paymentStatus }}<br>
        Type: {{ type }}<br>
        showPaymentError: {{ showPaymentError }}<br>
        showPaymentFailure: {{ showPaymentFailure }}<br>
        showPaymentSuccessful: {{ showPaymentSuccessful }}<br>
        <strong>Type:</strong> {{ type }}
        <div class="processing-results">
          <h3>Processing Results</h3>
          <pre>
        {{ JSON.stringify(processingResult, null, 2) }}
      </pre>
        </div>
      </div>
    </div>
    <div v-if="type">
      <square-success-response-modal
        v-if="successComponent !== false"
        :component="successComponentActual"
        :debug="debug"
        @closed="modalClosed(true)"
      />
      <square-failure-response-modal
        v-if="failureComponent !== false"
        :component="failureComponentActual"
        :debug="debug"
        @closed="modalClosed(false)"
      />
      <square-error-response-modal
        v-if="errorComponent !== false"
        :component="errorComponentActual"
        :debug="debug"
        @closed="modalClosed()"
      />
    </div>
    <square-timeout-response-modal
      v-if="timeoutComponent !== false"
      :component="timeoutComponentActual"
      :debug="debug"
      :show-payment-timeout="showPaymentTimeout"
      :elapsed-time="timeoutElapsedTime"
      :next-wait-duration="timeoutWaitDuration"
      @manual-confirm="handleManualConfirm"
      @continue-waiting="handleContinueWaiting"
      @cancel-payment="handleCancelPayment"
    />
  </div>
</template>

<script>

import successModalWrapper from './wrappers/success-wrapper.vue'
import failureModalWrapper from './wrappers/failure-wrapper.vue'
import errorModalWrapper from './wrappers/error-wrapper.vue'
import timeoutModalWrapper from './wrappers/timeout-wrapper.vue'

import PaymentErrorContent from './content/payment-error.vue'
import PaymentFailureContent from './content/payment-failure.vue'
import PaymentSuccessContent from './content/payment-success.vue'
import PaymentTimeoutContent from './content/payment-timeout.vue'

import StorecardErrorContent from './content/storecard-error.vue'
import StorecardFailureContent from './content/storecard-failure.vue'
import StorecardSuccessContent from './content/storecard-success.vue'
import PaymentResponseMixins from '../mixins/payment-response-mixins.js'
import SquarePaymentsMixin from '../mixins/square-payments'

export default {
  name: 'square-payment-response-modals',
  components: {
    'square-success-response-modal': successModalWrapper,
    'square-failure-response-modal': failureModalWrapper,
    'square-error-response-modal': errorModalWrapper,
    'square-timeout-response-modal': timeoutModalWrapper
  },
  mixins: [
    PaymentResponseMixins,
    SquarePaymentsMixin
  ],
  props: {
    successComponent: {
      type: [Object, Boolean],
      required: false,
      default: () => null
    },
    failureComponent: {
      type: [Object, Boolean],
      required: false,
      default: () => null
    },
    errorComponent: {
      type: [Object, Boolean],
      required: false,
      default: () => null
    },
    timeoutComponent: {
      type: [Object, Boolean],
      required: false,
      default: () => null
    },
    showPaymentTimeout: {
      type: Boolean,
      required: false,
      default: false
    },
    timeoutElapsedTime: {
      type: Number,
      required: false,
      default: 30
    },
    timeoutWaitDuration: {
      type: Number,
      required: false,
      default: 30
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    debugProdcessingResults: function() {
      return this.debug && this.processingResults && this.processingResult.length > 0
    },
    successComponentActual: function() {
      return this.successComponent ? this.successComponent : this.type === 'payment' ? PaymentSuccessContent : StorecardSuccessContent
    },
    errorComponentActual: function() {
      return this.errorComponent ? this.errorComponent : this.type === 'payment' ? PaymentErrorContent : StorecardErrorContent
    },
    failureComponentActual: function() {
      return this.failureComponent ? this.failureComponent : this.type === 'payment' ? PaymentFailureContent : StorecardFailureContent
    },
    timeoutComponentActual: function() {
      return this.timeoutComponent ? this.timeoutComponent : PaymentTimeoutContent
    }
  },
  methods: {
    modalClosed: function(val) {
      this.$emit('closed', val)
    },
    handleManualConfirm() {
      this.$emit('manual-confirm')
    },
    handleContinueWaiting(data) {
      this.$emit('continue-waiting', data)
    },
    handleCancelPayment() {
      this.$emit('cancel-payment')
    }
  }
}
</script>

<style>

</style>
